// Heart-rate zone floors for the signed-in profile, for anything that colours
// heart rate by zone (charts, readouts). Its own tiny module so charts don't
// pull WorkoutContext's import tree in. Provided by WorkoutProvider.
import { createContext, useContext } from "react";

export const ZoneFloorsContext = createContext(null);

/** [Z1..Z5] floors in bpm, or null when zones aren't known. */
export const useZoneFloors = () => useContext(ZoneFloorsContext);
